import * as App from './app'
import * as Common from './common'
import * as DictApi from './dict'
import * as Company from './company'

const ApiService = {
  App,
  Common,
  DictApi,
  Company
}


export default ApiService
